(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('WeekschemeService', ['$http', WeekschemeServiceFn]);

    /* service for requesting weekschemes */
    function WeekschemeServiceFn($http) {
        var baseUrl = '/api/weekschemes/';

        var service = {
            query: query,
            get: get,
            deactivate: deactivate,
            activate: activate,
            update: update,
            save: save,
            reorder: reorder,
            type: type
        };

        return service;

        /* query all schemes of user */
        function query(userId, individual, all) {
            return $http.get(baseUrl + 'users/' + userId + '/' + individual + '/' + all).then(function (response) {
                return response.data;
            });
        }

        /* get */
        function get(userId) {
            return $http.get(baseUrl + userId).then(function (response) {
                return response.data;
            });
        }

        /* deactivate */
        function deactivate(id) {
            return $http.delete(baseUrl + id).then(function (response) {
                return response.data;
            });
        }
        
        function activate(id) {
            return $http.put(baseUrl + id + '/activate').then(function (response) {
                return response.data;
            });
        }

        /* update */
        function update(id, item) {
            return $http.put(baseUrl + id, item).then(function (response) {
                return response.data;
            });
        }

        /* save */
        function save(item) {
            return $http.post(baseUrl, item).then(function (response) {
                return response.data;
            });
        }

        /* reorder */
        function reorder(id, relatedId) {
            return $http.put(baseUrl + 'order/' + id + '/' + relatedId).then(function (response) {
                return response.data;
            });
        }

        /* change type */
        function type(id, relatedId) {
            return $http.put(baseUrl + 'type/' + id).then(function (response) {
                return response.data;
            });
        }

    }
})();